import { Component, OnInit, ViewChild } from '@angular/core';
import { FormInputTypes } from '../../models/formtemplate';
import * as firebase from 'firebase'
import { FirebaseService } from '../../services/firebase.service';
import { Logger } from 'src/app/services/datadog.logger.service';
import { ActivatedRoute } from '@angular/router';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { range } from 'rxjs';

@Component({
  selector: 'app-view-only',
  templateUrl: './view-only.component.html',
  styleUrls: ['./view-only.component.less', '../../../assets/style.less']
})
export class ViewOnlyComponent implements OnInit {

  formTemplate;

  clientFormGroup: FormGroup

  user;

  formResponse = {}

  client = {}

  @ViewChild('clientForm') clientForm;

  constructor(
    private service:FirebaseService,
    private logger: Logger,
    private route: ActivatedRoute) { 

    const formTemplateId = this.route.snapshot.paramMap.get("formId")

    this.service.getForm(formTemplateId).subscribe(result => {
      this.logger.info(`Retrieved form template with ID ${formTemplateId}`)
      // this.service.log(`Retrieved form template with ID ${formTemplateId}`)
      this.formTemplate = result.data()
      console.log(result.data())
      this.clientFormGroup = new FormGroup(this.getFormValidationObject(this.formTemplate))
    }, err => {
      this.logger.error(`Error retrieving form template with ID ${formTemplateId}`, err ? err : '')
      // this.service.log(`Error retrieving form template with ID ${formTemplateId}`, err)
    })

    const filledFormId = this.route.snapshot.paramMap.get("filledFormId")
    if (filledFormId) {
      this.service.getFilledFormById(filledFormId).subscribe(filledForm => {
        this.logger.info(`Retrieved filled form by Id: ${filledFormId}`)
        // this.service.log(`Retrieved filled form by Id: ${filledFormId}`)
        this.formResponse = filledForm.data
      }, err => {
        this.logger.error(`Error retrieving the filled form by ID: ${filledFormId}`, err ? err : '')
        // this.service.log(`Error retrieving the filled form by ID: ${filledFormId}`, err)
      })
      
    }
  }

  ngOnInit() {
  }

    // Create a validation object necessary to apply validators to the form
    getFormValidationObject(form: any) {
      this.logger.info(`Entering method getFormValidationObject.
    Parameters: form=${form}`)
      var validationObject = {}
      form.sections.forEach(section => {
        section.data.forEach(input => {
          if (input.type != FormInputTypes.IMAGE) {
            if (input.type == FormInputTypes.CHECKBOX) {
              validationObject[input.id] = new FormControl(false, input.required == true ? [Validators.requiredTrue] : [])
            } else {
              validationObject[input.id] = new FormControl('', input.required == true ? [Validators.required] : [])
            }
          }
        })
      });
  
      this.logger.info('Exiting method getFormValidationObject')
      return validationObject
    }

      /**
   * The templates contain tags that have the following template - {{tag.name}} - This function replaces these tags with actual content
   * @param data The string to replace the tags for, ex: {{businessName}}
   */
  replaceTags(data: string) {

    this.logger.info(`Entering method replaceTags.
    Parameters: data=${data}`)
    // Get where the tags start and end within the string
    let startIndex = data.indexOf("{{")
    let endIndex = data.indexOf("}}", startIndex)

    while (startIndex != -1) {
      if (startIndex != -1 && endIndex != -1) {
        let tag = data.substring(startIndex + "{{".length, endIndex)
        let point = tag.indexOf('.')

        // If there's a decimal point in this tag
        if (point != -1) {
          let tags = tag.split('.')
          if (tags[0] === 'user') {
            if (this.user) {
              let tagReplacement = this.user[tags[1]]
              data = data.replace(tag, tagReplacement)
            }            
          }
        } else {
          data = data.replace(tag, this.formTemplate[tag])
        }
      }

      startIndex = data.indexOf("{{", endIndex)
      endIndex = data.indexOf("}}", startIndex)
    }

    data = data.replace("{{", "")
    data = data.replace("}}", "")

    this.logger.info('Exiting method replaceTags')
    return data
  }
}
